import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private googleTagManagerId: string;

  constructor(
    private logger: LoggerService,
    private configService: ConfigService
  ) {
  }

  /**
   * Inserts google tag manager script in <head>, takes google tag manager id from the configuration received.
   * If in devMode dont insert.
   */

  public init() {
    if (this.configService.initError) {
      return;
    }

    if (this.configService.devMode) {
      this.logger.info('No google tag manager for you (development environment)');
      return;
    }

    this.googleTagManagerId = this.configService.get().googleTagManagerId;

    if (!this.googleTagManagerId) {
      return this.logger.warn('No Google Tag Manager for you');
    }

    if (!this.configService.isLearningRoomBecasSantander()) {
      const googleTagManagerScript = document.createElement('script');
      googleTagManagerScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${this.googleTagManagerId}');`;
      document.head.appendChild(googleTagManagerScript);
    }
  }
}
